import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Typo, TypoUpdate } from "@/model";
import typoRepository from "@/repository/typoRepository";
import { typoQueryKeys } from "./keys";


export const useUpdateTypo = (agentId: number, typoId?: string) => {
    const queryClient = useQueryClient();

    return useMutation<Typo, AxiosError, TypoUpdate>({
        mutationKey: ["typo", "agent", agentId, "typo", typoId, "update"],
        mutationFn: async (body: TypoUpdate) => {
            try {
                const { data } = await typoRepository.update(agentId, typoId!, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: typoQueryKeys.all(agentId)
            });
        }
    });
};
